import { FlowBasic } from '../../../flow/serverApi/types/Flow';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IBasicDataSource } from '../../ServerApi/types/IDataSource';
import { IDataConnection } from './types/IDataConnection';

export interface IGetDataConnectionsParams extends IGetItemsParams {
}

export interface IGetDataConnectionsResult extends IGetItemsResult {
  dataConnections?: IDataConnection[];
  datasources?: IBasicDataSource[];
  readonly flows?: ReadonlyArray<FlowBasic>;
  projects?: INamedItem[];
  users?: IUser[];
  workbooks?: INamedItem[];
}

export class GetDataConnectionsRequest extends Request<IGetDataConnectionsParams, IGetDataConnectionsResult> {
  constructor(params: IGetDataConnectionsParams) {
    super('getDataConnections', params);
  }
}
